import { PATH } from '@/constants/path';
import { Badge, BadgeProps } from '@shopify/polaris';
import { StarFilledIcon } from '@shopify/polaris-icons';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface CustomBadgeProps extends Omit<BadgeProps, ''> {
  position?: string;
  hasIcon?: boolean;
  marginLeft?: boolean;
  marginRight?: boolean;
}
const CustomBadge = ({ hasIcon = true, marginLeft = true, ...props }: CustomBadgeProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const handleRedirectPricing = () => {
    navigate(PATH.PRICING_PLAN);
  };

  const className = `pointer ${marginLeft ? 'ml-4' : ''} ${props.marginRight ? 'mr-4' : ''}`;

  return (
    <span className={className} onClick={handleRedirectPricing}>
      <Badge icon={hasIcon ? StarFilledIcon : undefined} tone={props.tone || 'info'}>
        {props.children || t('paid_plan')}
      </Badge>
    </span>
  );
};

export default memo(CustomBadge);
